import { ArrowRight, BrainCircuit } from "lucide-react";
import { Reveal, SectionHeading } from "../components/site/Reveal";
import { MagneticButton } from "../components/site/MagneticButton";
import { useCalendly } from "../components/site/CalendlyModal";

const IDEAS = [
  "Clasificar y responder solicitudes de clientes automáticamente",
  "Extraer datos de documentos con OCR + IA y eliminar digitación",
  "Consolidar información dispersa en tableros en tiempo real",
  "Anticipar decisiones con analítica predictiva sobre tus datos",
];

export const AISection = () => {
  const { openCalendly } = useCalendly();
  return (
    <section id="motor-ia" className="relative py-28 md:py-40 bg-[var(--bg2)] overflow-hidden" data-testid="ai-section">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[720px] h-[420px] rounded-full bg-[var(--green)]/8 blur-[160px]" aria-hidden="true" />
      <div className="relative mx-auto max-w-5xl px-6">
        <SectionHeading
          align="center"
          eyebrow="Inteligencia Artificial"
          title={<>La inteligencia artificial empieza con <span className="text-gradient">una buena pregunta.</span></>}
          copy="Cuéntanos qué proceso quieres mejorar y en una conversación te mostramos cómo podría transformarse."
          testId="ai-heading"
        />
        <Reveal delay={0.15} className="mt-14">
          <div className="rounded-3xl border border-[var(--line)] bg-[var(--surface)]/70 p-8 md:p-12" data-testid="ai-panel">
            <p className="mono text-[11px] tracking-[0.3em] uppercase text-[var(--green)] mb-8 text-center">
              Lo que la IA puede hacer por tu operación
            </p>
            <div className="grid gap-4 sm:grid-cols-2">
              {IDEAS.map((idea, i) => (
                <Reveal key={idea} delay={0.1 + i * 0.08}>
                  <div className="flex items-start gap-3.5 rounded-2xl border border-[var(--line)] bg-[var(--bg2)] px-5 py-4 h-full">
                    <BrainCircuit size={17} className="mt-0.5 shrink-0 text-[var(--cyan)]" />
                    <span className="text-sm leading-relaxed text-[var(--ink)]/85">{idea}</span>
                  </div>
                </Reveal>
              ))}
            </div>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              <MagneticButton onClick={openCalendly} testId="ai-cta-agendar">
                Analizar mi proceso con un especialista <ArrowRight size={15} className="text-[var(--green)]" />
              </MagneticButton>
              <MagneticButton variant="ghost" to="/inteligencia-artificial" testId="ai-cta-conocer">
                Conocer más sobre IA
              </MagneticButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
